import React, { useEffect, useRef, useState } from 'react';
import { Box, Grid, Stack } from '@mui/material';
import { isEnvTypePROD } from '../../service/config';
import '../TableauObs/Summary/Summary.scss';
import moment from 'moment';
import { useSearchParams } from 'react-router-dom';
import { getDecodedToken, fetchDECostTabel, fetchDEStorageTrends, fetchDECostSummary, getDataEstateSector } from '../../service/service';
import '../DataEstate/data-estate.scss';
import '../DataEstate/data-estate-dashboard.scss';
import { formatNumberWithCommas } from '../../utils/common-util';
import { CustomizedDataGrid } from '../customized_data_grid';
import Loader from '../Loader/loader';
import { Column } from 'react-data-grid';
import { useCacheDataController } from 'Context/contexts/CacheDataContext';
import NumberWidget from 'components/Widgets/NumberWidget';
import ChartWidget from 'components/Widgets/ChartWidget';
import { sectorListDetails } from 'Context/contexts/cacheData/DataEstate/type';
import PageWrapper from 'components/Common/PageWraper';
import HighlightedText from 'components/GlobalSearch/HighlightText';
import { useFinOpsTab } from 'Context/contexts/FinOpsTabContext';

const CostSummary = () => {
	const { filterMonth } = useFinOpsTab();
	const [searchParams] = useSearchParams();
	const hasDrillDown = searchParams.has('isDrillDowned');
	const [DatabricksCost, SetDatabricksCost] = useState('_')
	const [TeraDataCost, SetTeraDataCost] = useState('_')
	const [AzureCost, SetAzureCost] = useState('_')
	const [, SetReservedInsSaving] = useState('_')
	const [, SetDatabricksQueryCost] = useState('_')
	const [, SetTeradataQueryCost] = useState('_')
	const [, SetPrestoQueryCost] = useState('_')

	const [, setGrafanaDatabricksLoading] = useState(true);
	const [grafanaDatabricksOptions, setGrafanaDatabricksOptions] = useState<any>()
	const [, setGrafanaTeradataLoading] = useState(true);
	const [grafanaTeradataOptions, setGrafanaTeradataOptions] = useState<any>()
	const [, setGrafanaAzureLoading] = useState(true);
	const [grafanaAzureOptions, setGrafanaAzureOptions] = useState<any>()
	const [lastUpdatedDateDatabricks, setLastUpdatedDateDatabricks] = useState('')
	const [lastUpdatedDateTeradata, setLastUpdatedDateTeradata] = useState('')
	const [lastUpdatedDateAzure, setLastUpdatedDateAzure] = useState('')
	const [customMonth, setCustomMonth] = useState('');
	const [controller] = useCacheDataController();
	const { azureCostSummaryLastSyncDate } = controller;
	const [isLoading, setIsLoading] = useState(false);

	// sector filter
	const userSector = getDecodedToken()?.sector?.name?.toLowerCase();
	const [sectorOptionsList, setSectorOptionsList] = useState<any[]>([]);
	const [, setCheckedList] = useState<any[]>([]);
	const [, setCurrSectorFilter] = useState<any[]>([]);
	const [sector] = useState<any[]>([]);
	const dataFetchedRef = useRef(false);
	const [sectorName] = useState('all');

	const [allSectorDatabricksCostData] = useState(() => {
		const sectorData = localStorage.getItem('databricksCost');
		return sectorData != undefined ? JSON.parse(sectorData) : null;
	});

	const [allSectorTeradataCostData] = useState(() => {
		const sectorData = localStorage.getItem('teradataCost');
		return sectorData == undefined ? null : JSON.parse(sectorData);
	});

	const [allSectorAzureCostData] = useState(() => {
		const sectorData = localStorage.getItem('azureCost');
		return sectorData == undefined ? null : JSON.parse(sectorData);
	});
	// table
	const [tableName, setTableName] = useState('');
	const [typeName, setTypeName] = useState('');

	interface DBCLUSTERS {
		workspace: string;
		clusterType: string;
		clusterName: string;
		totalDBU: string;
		totalDBUCost: string;
		totalComputeCost: string;
	}
	interface TERADATA {
		workload: string;
		totalTCoreHours: string;
		tCoreDailyAverage: string;
		totalCost: string;
	}
	interface AZURE {
		subscription: string;
		resourceGroup: string;
		resource: string;
		location: string;
		totalCost: string;
	}
	interface YTD {
		programName: string;
		total_cost: string;
	}
	interface AVERAGECOST {
		workload: string;
		tCoreUsagePerQuery: string;
		totalQueries: string;
		totalCostPerQuery: string;
	}
	interface Row { };
	function getColumns(): Array<Column<Row>> {
		if (typeName === 'DBCLUSTERS') {
			return [
				{
					key: 'workspace',
					name: 'Workspace',
					minWidth: 150
				},
				{
					key: 'clusterType',
					name: 'Cluster type',
					minWidth: 170,
				},
				{
					key: 'clusterName',
					name: 'Cluster name',
					minWidth: 170,
				},
				{
					key: 'totalDBU',
					name: 'Total DBU',
					minWidth: 170,
				},
				{
					key: 'totalDBUCost',
					name: 'Total DBU Cost',
					minWidth: 170,
				},
				{
					key: 'totalComputeCost',
					name: 'Total compute cost',
					minWidth: 170,
				}
			];
		}
		else if (typeName === 'TERADATA') {
			return [
				{
					key: 'workload',
					name: 'Workload',
					minWidth: 150
				},
				{
					key: 'totalTCoreHours',
					name: 'Total T-Core hours',
					minWidth: 170,
				},
				{
					key: 'tCoreDailyAverage',
					name: 'T-Core daily average',
					minWidth: 170,
				},
				{
					key: 'totalCost',
					name: 'Total cost',
					minWidth: 170,
				}
			];
		}
		else if (typeName === 'AZURE') {
			return [
				{
					key: 'subscription',
					name: 'Subscription',
					minWidth: 150
				},
				{
					key: 'resourceGroup',
					name: 'Resource group',
					minWidth: 170,
				},
				{
					key: 'resource',
					name: 'Resource',
					minWidth: 170,
				},
				{
					key: 'location',
					name: 'Location',
					minWidth: 170,
				},
				{
					key: 'totalCost',
					name: 'Total cost',
					minWidth: 170,
				}
			];
		}
		else if (typeName === 'YTD') {
			return [
				{
					key: 'programName',
					name: 'Year',
					minWidth: 150
				},
				{
					key: 'total_cost',
					name: 'YTD Reserved instance savings',
					minWidth: 170,
				}
			];
		}
		else if (typeName === 'AVERAGECOST') {
			return [
				{
					key: 'workload',
					name: 'Workload',
					minWidth: 150
				},
				{
					key: 'tCoreUsagePerQuery',
					name: 'T-Core usage per query',
					minWidth: 170,
				},
				{
					key: 'totalQueries',
					name: 'Total queries',
					minWidth: 170,
				},
				{
					key: 'totalCostPerQuery',
					name: 'Total cost per query',
					minWidth: 170,
				}
			];
		}
		else {
			return [];
		}
	}
	const DatabricksClustersColumnNames = ['Workspace', 'Cluster type', 'Cluster name', 'Total DBU', 'Total DBU Cost', 'Total compute cost'];
	const TeradataColumnNames = ['Workload', 'Total T-Core hours', 'T-Core daily average', 'Total cost'];
	const AzureColumnNames = ['Subscription', 'Resource group', 'Resource', 'Location', 'Total cost'];
	const YTDColumnNames = ['Year', 'YTD Reserved instance savings'];
	const AverageCostColumnNames = ['Workload', 'T-Core usage per query', 'Total queries', 'Total cost per query'];
	const [defaultColumnNames, setDynamicValue] = useState(['']);
	const [tableData, setTableData] = useState<Row[]>([]);
	const [sortingInfo, setSortingInfo] = useState({ sortBy: '', sortDir: '' });
	const [paginationData, setPaginationData] = useState({ totalElements: 0, totalPages: 0 });
	const [page, setPage] = useState(1);
	const [pageSize, setPageSize] = useState(100);
	const [isDetailVisible, setIsDetailVisible] = useState(false);
	const dimension = useRef('');
	const kpiName = useRef('');
	const [, setLoading] = useState(false);
	const tableRef = useRef<HTMLDivElement>(null);

	const [allSectorOptionsList, setAllSectorOptionsList] = useState<sectorListDetails | null>(null);
	const [sectorTagList, setSectorTagList] = useState<any>({ azure: true, databricks: true, teradata: true });

	const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
		summaryListingFunc(value, pageSize, sortingInfo, kpiName, dimension);
	};

	const handlepageSizeChange = (event: any) => {
		summaryListingFunc(page, event.target.value, sortingInfo, kpiName, dimension);
	};

	async function summaryListingFunc(pageNumber: any, size: any, sortingInfo: any, kpiName: any, dimension: any) {
		setLoading(true);
		let month = customMonth ? customMonth : filterMonth;
		const res = await fetchDECostTabel(kpiName.current, dimension.current, sector, month);
		if (res.success) {
			setLoading(false);
			setTableData(res.data.summary);
			setPaginationData(res.data.page);
			setPage(pageNumber);
			setPageSize(size);
			setSortingInfo(sortingInfo);
		}
	}

	const handleSorting = (sortingInfo: any) => {
		summaryListingFunc(page, pageSize, sortingInfo, kpiName, dimension);
	};

	const handleDataEstateOnclick = (value: any) => {
		setDynamicValue(['']);
		setTableData([]);
		setIsDetailVisible(true);
		setTimeout(() => {
			if (tableRef.current) {
				tableRef.current.scrollIntoView({ behavior: 'smooth' });
			}
		}, 1000);
		setTypeName(value);
		if (value === 'DBCLUSTERS') {
			setDynamicValue(DatabricksClustersColumnNames);
			type Row = keyof DBCLUSTERS;
			setTableName("Cost of Databricks Clusters");
			kpiName.current = 'platformcost'
			dimension.current = 'databricks'
		}
		else if (value === 'TERADATA') {
			setDynamicValue(TeradataColumnNames);
			type Row = keyof TERADATA;
			setTableName("Cost of Teradata");
			kpiName.current = 'platformcost'
			dimension.current = 'teradata'
		}
		else if (value === 'AZURE') {
			setDynamicValue(AzureColumnNames);
			type Row = keyof AZURE;
			setTableName("Cost of Azure");
			kpiName.current = 'platformcost'
			dimension.current = 'azure'
		}
		else if (value === 'YTD') {
			setDynamicValue(YTDColumnNames);
			type Row = keyof AZURE;
			setTableName("YTD Reserved Instance Savings");
		}
		else if (value === 'AVERAGECOST') {
			setDynamicValue(AverageCostColumnNames);
			type Row = keyof AVERAGECOST;
			setTableName("Cost of a Query on Teradata");
			kpiName.current = 'querycost'
			dimension.current = 'teradata'
		}
		summaryListingFunc(page, pageSize, sortingInfo, kpiName, dimension)

	}

	async function fetchSectorOptionsData() {
		const sectorRes = await fetchDECostSummary('platformcost', 'sector', '', '')
		if (sectorRes.success) {
			if (sectorRes.data) {
				setAllSectorOptionsList(sectorRes.data);
			}
			const sectorKpiRes = await getDataEstateSector();
			if (sectorKpiRes.success) {
				if (sectorKpiRes.data) {
					const sectorValues = sectorKpiRes.data.map((item: { sector: any; }) => item.sector);
					const uniqueSectors = Array.from(new Set(sectorValues));
					const sectorNameList: string[] = uniqueSectors.map(sector =>
						(sector === "" || sector === null || sector === undefined) ? "Blank" : String(sector)
					);
					const sortedSectors = [...sectorNameList].sort((a: string, b: string) => a.localeCompare(b));
					setSectorOptionsList(sortedSectors);
				}
			}
		}
	}

	async function getCostSummaryDetails(sectorName1: any, month: any) {
		console.log(sectorName1, "name1==")
		setIsLoading(true);
		// Trend APIs
		SetDatabricksCost('-')
		SetTeraDataCost('-')
		SetAzureCost('-')
		SetReservedInsSaving('-')
		SetDatabricksQueryCost('-')
		SetTeradataQueryCost('-')
		SetPrestoQueryCost('-')
		// DATABRICKS
		Promise.all([
			fetchDEStorageTrends('costSummary', 'databricks', sectorName1, filterMonth),
			fetchDEStorageTrends('costSummary', 'teradata', sectorName1, filterMonth),
			fetchDEStorageTrends('costSummary', 'azure', sectorName1, filterMonth)
		]).then(([databrickRes, teradataRes, azureRes]) => {
			// cost
			databrickTrend(databrickRes.data);
			// Teradata
			teradataTrend(teradataRes.data);
			// Azure
			azureTrend(azureRes.data);

		}).catch((error: any) => {
			console.error(error);
		}).finally(() => {
			setIsLoading(false);
		})

		// Summary APIs
		fetchDECostSummary('platformcost', 'databricks', sectorName1, month).then(res => {
			let cost = res?.data?.result[0]?.cost
			SetDatabricksCost((cost / 1000000).toFixed(2).toString());
			if (sectorName1 == 'all') {
				localStorage.setItem('databricksCost', JSON.stringify((cost / 1000000).toFixed(2).toString()));
			}
		}).catch(error => {
			console.error(error);
		})
		fetchDECostSummary('platformcost', 'teradata', sectorName1, month).then(res => {
			let cost = res?.data?.result[0]?.cost
			SetTeraDataCost((cost / 1000000).toFixed(2).toString());
			if (sectorName1 == 'all') {
				localStorage.setItem('teradataCost', JSON.stringify((cost / 1000000).toFixed(2).toString()));
			}
		}).catch(error => {
			console.error(error);
		})
		fetchDECostSummary('platformcost', 'azure', sectorName1, month).then(res => {
			let cost = res?.data?.result[0]?.cost
			SetAzureCost((cost / 1000000).toFixed(2).toString());//
			if (sectorName1 == 'all') {
				localStorage.setItem('azureCost', JSON.stringify((cost / 1000000).toFixed(2).toString()));
			}
		}).catch(error => {
			console.error(error);
		})
	}
	const todaysDate = moment().utc().format('YYYY-MM-DD');
	const azureTrend = (resData: any) => {
		setGrafanaAzureOptions(resData.data);
		setGrafanaAzureLoading(false);
		setLastUpdatedDateAzure(resData.lastUpdatedDate ? resData.lastUpdatedDate : todaysDate);
	};

	const teradataTrend = (resData: any) => {
		setGrafanaTeradataOptions(resData.data);
		setGrafanaTeradataLoading(false);
		setLastUpdatedDateTeradata(resData.lastUpdatedDate ? resData.lastUpdatedDate : todaysDate);
	};

	const databrickTrend = (resData: any) => {
		setGrafanaDatabricksOptions(resData.data);
		setGrafanaDatabricksLoading(false);
		setLastUpdatedDateDatabricks(resData.lastUpdatedDate ? resData.lastUpdatedDate : todaysDate);
	};

	useEffect(() => {

		if (hasDrillDown) {

			const selectedSector = localStorage.getItem('selectedSector')
			if (selectedSector) {
				const selectedSec = JSON.parse(selectedSector).length ? JSON.parse(selectedSector) : ''
				setCheckedList(selectedSec)
				setCurrSectorFilter(selectedSec)
			}
		} else {
			localStorage.removeItem('selectedSector')
		}

		if (dataFetchedRef.current) return;
		dataFetchedRef.current = true;
		if (userSector === 'all') fetchSectorOptionsData();
		const activeId = document.getElementById('root');
		if (window.location.pathname === '/dataestate/costSummary') {
			if (activeId) {
				document.head.classList.add('theme-bg-blue');
				document.body.classList.add('theme-bg-blue', 'custom-class');
				activeId.classList.add('jobs-list-table');
				activeId.classList.remove('jobs-list', 'root');
				document.body.classList.add('jobs-exe-datas');
				document.body.classList.remove('jobs-run-table');
				document.body.classList.add('jobs-list-datas', 'datefilter-align-sector', 'sector-label');
			}
		} else if (activeId) {
			document.body.classList.remove('jobs-list-datas');
			activeId.classList.add('root');
		}
		getCostSummaryDetails('all', filterMonth);

		return () => {
			const activeId = document.getElementById('root');
			document.head.classList.remove('theme-bg-blue');
			document.body.classList.remove('theme-bg-blue', 'custom-class', 'jobs-exe-datas', 'jobs-list-datas', 'datefilter-align-sector', 'sector-label', 'dashboard-panel-dataestate');
			if (activeId) {
				activeId.classList.remove('jobs-list-table');
				activeId.classList.add('root');
			}
		};
	}, []);

	const sectorTagUpdatefun = (sector: string) => {
		if (sector != 'all') {
			if (sector == 'Blank')
				sector = '';

			const isInAzure = allSectorOptionsList?.azure.some(item => item.sector === sector);
			const isInDatabricks = allSectorOptionsList?.databricksCost.some(item => item.sector === sector);
			const isInTeradata = allSectorOptionsList?.teraDataCost.some(item => item.sector === sector);
			const filteredData = {
				azure: isInAzure || false,
				databricks: isInDatabricks || false,
				teradata: isInTeradata || false
			};
			setSectorTagList(filteredData);
			if (filteredData.azure) getCostSummaryDetails(filteredData.azure ? sector : 'all', "");
			if (filteredData.databricks) getCostSummaryDetails(filteredData.databricks ? sector : 'all', "");
			if (filteredData.teradata) getCostSummaryDetails(filteredData.teradata ? sector : 'all', "")
		} else {
			getCostSummaryDetails('all', "");

		}
	}

	useEffect(() => {
		getCostSummaryDetails(sectorName, filterMonth);
	}, [filterMonth, sectorName]);

	const azureCostNumber = sectorTagList?.azure
		? AzureCost && AzureCost !== '-'
			? '$' + formatNumberWithCommas(AzureCost)
			: 0
		: '$' + formatNumberWithCommas(allSectorAzureCostData);

	const azureCostSectorLabel = sectorTagList?.azure ? (sectorName === 'all' ? '' : sectorName) : '';

	const databricksCostNumber = sectorTagList?.databricks
		? DatabricksCost && DatabricksCost !== '-'
			? '$' + formatNumberWithCommas(DatabricksCost)
			: 0
		: '$' + formatNumberWithCommas(allSectorDatabricksCostData);

	const databricksCostSectorLabel = sectorTagList?.databricks ? (sectorName === 'all' ? '' : sectorName) : '';

	const teradataCostNumber = sectorTagList?.teradata
		? TeraDataCost && TeraDataCost !== '-'
			? '$' + formatNumberWithCommas(TeraDataCost)
			: 0
		: '$' + formatNumberWithCommas(allSectorTeradataCostData);

	const teradataCostSectorLabel = sectorTagList?.teradata ? (sectorName === 'all' ? '' : sectorName) : '';

	return (
		<PageWrapper sx={{ mt: 0, pt: '36px !important', px: '32px !important' }}>
			<Grid container spacing={2} mt={0}>
				<Grid item xs={12} md={4}>
					<Stack spacing={2} height="100%">
						<Box width="100%" id="azure-cost">
							<NumberWidget
								title={<HighlightedText text="Azure Cost" />}
								tooltipLabel=""
								number={azureCostNumber}
								isLoading={!AzureCost || AzureCost === '-'}
								units="MM"
								handleEvent={isEnvTypePROD ? undefined : () => handleDataEstateOnclick('AZURE')}
								sectorLabel={azureCostSectorLabel}
								bgColor="#FBFDFF"
								color="#000000"
								valueFontSize="48px"
								valueFontWeight={400}
							/>
						</Box>
						<Box width="100%" id="azure-cost-trend">
							<ChartWidget
								title={<HighlightedText text="Azure Cost Trend" />}
								data={grafanaAzureOptions}
								isLoading={isLoading}
								conversionUnitProp="cost"
								lastUpdatedDate={lastUpdatedDateAzure}
								restrictToMillions={true}
								themeMode="lightTrend"
								isForeCast={true}
							/>
						</Box>
					</Stack>
				</Grid>
				<Grid item xs={12} md={4}>
					<Stack spacing={2} height="100%">
						<Box width="100%" id="databricks-cost">
							<NumberWidget
								title={<HighlightedText text="Databricks Cost" />}
								tooltipLabel=""
								number={databricksCostNumber}
								isLoading={!DatabricksCost || DatabricksCost === '-'}
								units="MM"
								handleEvent={isEnvTypePROD ? undefined : () => handleDataEstateOnclick('DBCLUSTERS')}
								sectorLabel={databricksCostSectorLabel}
								bgColor="#FBFDFF"
								color="#000000"
								valueFontSize="48px"
								valueFontWeight={400}
							/>
						</Box>
						<Box width="100%" id="databricks-cost-trend">
							<ChartWidget
								title={<HighlightedText text="Databricks Cost Trend" />}
								data={grafanaDatabricksOptions}
								isLoading={isLoading}
								conversionUnitProp="cost"
								lastUpdatedDate={lastUpdatedDateDatabricks}
								restrictToMillions={true}
								themeMode="lightTrend"
								isForeCast={true}
							/>
						</Box>
					</Stack>
				</Grid>
				<Grid item xs={12} md={4}>
					<Stack spacing={2} height="100%">
						<Box width="100%" id="teradata-cost">
							<NumberWidget
								title={<HighlightedText text="Teradata Cost" />}
								tooltipLabel=""
								number={teradataCostNumber}
								isLoading={!TeraDataCost || TeraDataCost === '-'}
								units="MM"
								handleEvent={isEnvTypePROD ? undefined : () => handleDataEstateOnclick('TERADATA')}
								sectorLabel={teradataCostSectorLabel}
								bgColor="#FBFDFF"
								color="#000000"
								valueFontSize="48px"
								valueFontWeight={400}
							/>
						</Box>
						<Box width="100%" id="teradata-cost-trend">
							<ChartWidget
								title={<HighlightedText text="Teradata Cost Trend" />}
								data={grafanaTeradataOptions}
								isLoading={isLoading}
								conversionUnitProp="cost"
								lastUpdatedDate={lastUpdatedDateTeradata}
								restrictToMillions={true}
								themeMode="lightTrend"
								isForeCast={true}
							/>
						</Box>
					</Stack>
				</Grid>
				{/* detail part */}
				{isDetailVisible && (
					<>
						<h2 className="panel-legend--title mt-35 ">{tableName}</h2>
						<div className=" dataestate_tabledata" ref={tableRef}>
							<Grid>
								{tableData && tableData.length > 0 ? (
									<CustomizedDataGrid
										tableColumns={getColumns()}
										tableData={tableData}
										tableType="sector"
										defaultColumnNames={defaultColumnNames}
										onSorting={handleSorting}
										currSorting={sortingInfo}
										page={page}
										pageSize={pageSize}
										paginationData={paginationData}
										listLength={tableData.length}
										handlepageSizeChange={handlepageSizeChange}
										handlePageChange={handlePageChange}
										isDateRangeFilter={false}
										isDisabled={false}
										isFetching={true}
									/>
								) : tableData ? (
									<Loader />
								) : (
									<span style={{ display: 'flex', justifyContent: 'center' }}>No Records Found</span>
								)}
							</Grid>
						</div>
					</>
				)}
			</Grid>
		</PageWrapper>
	);
};

export default CostSummary;
